import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

// Downloads the PDF receipt; body proves ownership (order no + email, or receipt no + parent contact).
export const ReceiptButton = ({ path, body, testid }) => {
  const { L } = useLang();
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const { data, headers } = await api.post(path, body, { responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(headers["content-disposition"] || "")?.[1] || "RoboSpark-receipt.pdf";
      const url = URL.createObjectURL(data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch (e) {
      const t = await e.response?.data?.text?.().catch(() => "");
      toast.error((() => { try { return JSON.parse(t).detail; } catch { return null; } })() || L("Could not download the receipt.", "रसीद डाउनलोड नहीं हो सकी।"));
    } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={download} disabled={busy} data-testid={testid}
      className="rounded-full border border-slate-300 bg-white px-4 h-10 inline-flex items-center gap-2 text-sm font-bold text-[#0A192F] hover:border-[#007A8A] hover:text-[#007A8A] transition-colors disabled:opacity-50">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}{L("Download PDF receipt", "PDF रसीद डाउनलोड करें")}
    </button>
  );
};
